export const GET_ALL_GRADES = 'GET_ALL_GRADES';
export const GET_ALL_GRADES_SUCCESS = 'GET_ALL_GRADES_SUCCESS';
export const GET_GRADE_DETAIL = 'get_grade_detail';
export const GET_GRADE_DETAIL_SUCCESS = 'get_grade_detail_success';
export const ADD_GRADES = 'ADD_GRADES';
export const DELETE_GRADES = 'DELETE_GRADES';
export const EDIT_GRADES= 'EDIT_GRADES';
export const SET_LOADER= 'SET_LOADER';